import { types, Instance } from 'mobx-state-tree';
const { model, string, maybeNull, maybe, boolean, number } = types;

export const syncZoomUserModel = model('syncZoomUserModel ', {
  display_name: string,
  last_name: string,
  first_name: maybe(string),
  description: maybe(string),
  email: maybe(string),
  isSuspended: maybe(boolean),
  telephonenumber: maybe(string),
  userpassword: maybe(string),
  homephone: maybe(string),
  isAdmin: maybe(boolean),
  includeInGlobalAddressList: maybe(boolean),
  creationTimestamp: maybeNull(string),
  updationTimestamp: maybeNull(string),
  isMailboxSetup: maybe(boolean),
  zoomId: maybeNull(string),
});
export type IsyncZoomUserModel = Instance<typeof syncZoomUserModel>;

export const syncZoomGroupModel = model('syncZoomGroupModel', {
  zoomId: maybeNull(string),
  total_members: number,
  name: string,
});
export type IsyncZoomGroupModel = Instance<typeof syncZoomGroupModel>;

export const StatisticModel = model('StatisticModel', {
  user: number,
  group: number,
  department: number,
});
export type IStatisticModel = Instance<typeof StatisticModel>;
